import { format } from 'react-string-format';
import { constants } from '../constants';
import useWebContext from '../hooks/useWebContext';
import { utility } from '../utility';

const useValidationRules = () => {
  const { messageList } = useWebContext();

  const rule = {
    /** 必須チェック */
    required: () => ({
      validate: (value) => value === null || value === undefined || value?.toString().trim().length === 0 ? messageList.MyM_MSG_E_0004 : null
    }),
    /** 必須チェック(条件付き) */
    conditionalRequired: (needsValid) => ({
      validate: (value) => needsValid && (value === null || value === undefined || value === '') ? messageList.MyM_MSG_E_0004 : null
    }),
    /** 文字数チェック */
    maxLength: (length) => ({ maxLength: { value: length, message: format(messageList.MyM_MSG_E_0068, length) } }),
    /** メールアドレス書式(ドメイン無し)チェック */
    mailAddressWithoutDomain: () => ({ pattern: { value: /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*$/, message: messageList.MyM_MSG_E_0024 }, }),
    /** メールアドレス書式チェック */
    mailAddress: () => ({ pattern: { value: /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/, message: messageList.MyM_MSG_E_0024 }, }),
    /** ファイルサイズチェック */
    fileSize: (inputFile, maxFileSize) => ({
      validate: {
        maxFileSize: () => {
          return !inputFile || inputFile?.size <= maxFileSize ? true : format(messageList.MyM_MSG_E_0013, Math.floor(utility.convertFileSize(maxFileSize, constants.FileSize.MB)))
        },
        notSizeZero: () => {
          return !inputFile || inputFile?.size > 0 ? true : messageList.MyM_MSG_E_0076
        }
      }
    }),

    // 2025.3.5 MyMine Version2.1対応 Modify Start
    /**
     * リスト必須チェック
     * @param {Array} list チェック配列
     * @param {Function} shouldValidFunc チェック実施必須判定関数（戻り値がtrueの場合のみチェック実施）
     * @param {bool} useInputValue Validationデフォルト引数の値をチェック値として使用するか否か(trueの場合、第一引数で指定したlistは使用されません)
     * @returns
     */
    listRequired: (list, shouldValidFunc, useInputValue) => ({
      validate: {
        message: (input) => {
          // 2024.9.16 MyMine Version2.0対応 Add Start
          if (shouldValidFunc && shouldValidFunc() === false) {
            return true;
          }
          // 2024.9.16 MyMine Version2.0対応 Add End
          const checkValue = useInputValue === true ? input : list;
          return checkValue.length < 1 ? messageList.MyM_MSG_E_0004 : true;
        }
      }
    }),
    // 2025.3.5 MyMine Version2.1対応 Modify End

    /** 半角文字チェック */
    alphanumericOnly: () => ({ pattern: { value: /^[A-Za-z0-9]*$/, message: messageList.MyM_MSG_E_0007 }, }),
    // 2024.9.16 MyMine Version2.0対応 Modify Start
    // 2024.5.8 MyMine Version1.5対応 Modify Start
    /**
     * 日付チェック
     * @param {any} name 項目名
     * @param {any} isRequired 必須要否
     * @param {any} fromDate 大小関係チェックを行う場合、Fromの値を設定する
     * @returns
     */
    date: (name, isRequired = false, fromDate = null) => ({
      // 2024.5.8 MyMine Version1.5対応 Modify End
      validate: {
        message: (input) => {
          // 2024.5.8 MyMine Version1.5対応 Add Start
          if (isRequired && !input)
            return messageList.MyM_MSG_E_0004
          // 2024.5.8 MyMine Version1.5対応 Add End
          // 未入力の状態では検証しない
          if (!input) return;

          if (isNaN(input["$y"]) || isNaN(input["$M"]) || isNaN(input["$D"]) || isNaN(input['$d'])) {
            return format(messageList.MyM_MSG_E_0033, name);
          }

          if (fromDate && new Date(fromDate) > input['$d']) {
            return format(messageList.MyM_MSG_E_0033, name);
          }
        }
      }
    }),
    // 2024.9.16 MyMine Version2.0対応 Modify End
  }
  return rule;
}
export default useValidationRules;